import React, {Fragment, useContext} from 'react'
import {Link} from 'react-router-dom'

import {ApiServiceContext, BasketContext} from '../../context'

import BasketPanelCard from './basket-panel-card'

const BasketPanel = ({setHiddenPanelClassName}) => {
  const apiService = useContext(ApiServiceContext);
  const {basket, setBasket, cartId, setCartId} = useContext(BasketContext);

  const handleDeleteClick = event => {
    event.preventDefault();
    const [id, size] = event.target.id.split('-');

    if (basket.length === 1) {
      setBasket([]);
      setCartId('')
    } else {
      const purchasing = {
        "id": parseInt(id),
        "size": parseInt(size),
        "amount": 0
      };

      apiService.setCart(`${cartId}`, purchasing)
        .then(({data}) => {
          const {products} = data;
          setBasket(products)
        })
        .catch(console.error)
    }
  };

  const productList = basket.map(({id, size, amount}) => (
    <BasketPanelCard params={id}
                     id={id}
                     size={size}
                     amount={amount}
                     handleDeleteClick={handleDeleteClick}
                     key={`${id}${size}`}/>
  ));

  return (
    <div className="hidden-panel__basket basket-dropped hidden-panel__basket_visible">
      {productList.length === 0 ?
        (<div className="product-list__item">
          <Link to="/" className="product-list__product">
            В корзине пока ничего нет. Не знаете, с чего начать? Посмотрите наши новинки!
          </Link>
        </div>) :
        (<Fragment>
          <div className="basket-dropped__title">В вашей корзине:</div>
          <div className="basket-dropped__product-list product-list"
               style={{overflowY: basket.length > 3 ? 'auto' : 'hidden'}}>
            {productList}
          </div>
          <Link className="basket-dropped__order-button"
                to="/order"
                onClick={() => setHiddenPanelClassName('')}>
            Оформить заказ
          </Link>
        </Fragment>)
      }
    </div>
  )
};

export default BasketPanel
